/* LA PILLOLA DI INBOX SI TOGLIE MENTRE IL DITO SCENDE (17/09/2026)
   ----------------------------------------------------------------
   Misurato: la pillola galleggia sopra la griglia e copre 1 920 px2 su ogni
   scheda della colonna destra a 390, e per intero il blocco «avvisami». I
   canali riservati nel footer non la toccano: li' la pillola non c'e', sta
   sopra il contenuto mentre si scorre.

   COME, e perche' cosi':
   - si sposta SOLO l'elemento ospite <shopify-chat> con un transform, da un
     ascoltatore nostro che mette una classe su <html>. Dentro lo shadow root
     non si entra: non serve, e non sarebbe nostro.
   - la chat resta raggiungibile in ogni momento con UN gesto solo: si risale,
     e torna. Non c'e' stato in cui sia irraggiungibile.
   - DEGRADAZIONE: se Shopify rinomina l'elemento, il selettore CSS non
     aggancia piu' e la pillola resta dov'e' oggi. Questo script mette solo una
     classe su <html>: senza il selettore e' inerte. Mai peggio di oggi.
   - quando la chat e' APERTA non si sposta niente: la regola e'
     shopify-chat:not([open]).

   Nessuna dipendenza, nessun ascoltatore sul resto della pagina, un solo
   rAF per raffica di scorrimento. */
/* CORREZIONE DEL 17/09, stessa giornata. Il commit che ha introdotto questo
   file dichiarava un «fatto non spiegato»: il sigillo che esce su ZG-36
   benche' i gate lo escludano. NON era un fatto: le letture erano fatte con
   curl, e il cookie dell'anteprima e' httpOnly, quindi curl ricadeva sul tema
   PUBBLICATO (212670611709), dove il sigillo c'e' davvero. Su ZG-36 il sigillo
   non e' mai uscito e i gate funzionavano. Verificato leggendo
   Shopify.theme.id nei due documenti.
   La regola era gia' in casa e la applicavo solo al browser: un URL nudo non
   dice quale tema serve, e vale anche per curl. */
/* LA BOLLA HA UN ANGOLO SUO (giro finale, voce p1-bolla, 08/10/2026; foglio 01 §1.1, foglio 03 §2.14,
   foglio 04 §1.2; correzioni del revisore lo stesso giorno). Nell'angolo in basso a destra non sta niente di
   fermo, e la regola ha TRE MODI, sempre gli stessi (mappa §1.5):
   1. IL FERMO SI SPOSTA: non e' di questo file. Le righe del picco dei produttori stanno a sinistra in ogni
      lingua; le righe d'acquisto della scheda prodotto al telefono chiudono prima dell'angolo con un
      padding-right fisico (luxury.css, «LO SPAZIO RISERVATO»), anche in arabo.
   2. SALE SOPRA LE BARRE IN FONDO: e' l'unico che scrive --shopify-chat-activator-offset, inline su <html>
      (Inbox lo scrive in :root dopo luxury.css: una regola del tema perderebbe). Le barre si dichiarano con
      data-zg-barra-fondo: vuoto = su quando e' position: fixed; altrimenti un selettore che la barra deve avere
      per essere su (".is-visible"). Offset = altezza della barra su piu' alta + 12 px al telefono (20 dai 768),
      diviso la scala della bolla (--zg-bolla-s, 0,96 al telefono: l'ospite si scala dall'angolo in basso a
      destra, quindi anche il suo offset). Il padding-bottom del body resta della barra: e' il meccanismo di
      lux-sticky-tools (foglio 04 §1.2), che prima scriveva anche l'offset, come la barra d'acquisto della voce 9:
      due proprietari, e quello che spariva per primo lo toglieva anche all'altro.
   3. ESCE MENTRE UN PANNELLO E' APERTO (html.zg-bolla-fuori): il cassetto e la tendina del carrello, ricerca,
      menu, preferiti, benvenuto, paese, il pannello dei filtri del catalogo al telefono e, dalla tappa 3 (voce
      t3-whatsapp-catalogo), l'indice e l'ingrandimento del visore del catalogo trade (.zg-cv-indice, .zg-cv-zoom,
      sections/zg-catalogue-viewer.liquid). Era sopra il piede del cassetto, col pagamento, a z-index 2147483000.
      I pannelli che si aprono con una classe si osservano (aggancia): aprirli rifa' subito il conto, non al
      prossimo scorrimento.
   In piu', da prima della regola, SCENDENDO ESCE (17/09, invariato): html.zg-chat-away; risalendo torna.
   LA RETE (non e' un quarto modo): a pagina ferma (150 ms dopo l'ultimo scorrimento, al load, al resize, quando
   cambia una barra o un pannello) si guarda l'angolo in 35 punti, bordi compresi, con document.elementsFromPoint
   (l'ospite si salta), e se ci sta qualcosa di fermo che i tre modi non hanno previsto la bolla esce
   (html.zg-bolla-fuori) e torna appena l'angolo e' libero. Fermo e' un bottone, un campo, un link nella sua
   scritta (o piccolo come un'icona), un prezzo o una scritta:
     - nella prima schermata a pagina ferma (scrollY <= 120, la quota sotto la quale la bolla non esce
       scendendo): quello che si vede aprendo la pagina;
     - dentro un antenato fixed o sticky (barre, palchi, colonne appiccicose): a ogni quota;
     - in LIBERI (il bottone della copertina in homepage, la riga del prezzo e quella del bottone della scheda
       prodotto, la barra di «Sort» del catalogo) e nell'ultima fila delle griglie di prodotti: a ogni quota.
   Con lo spazio riservato gli elementi elencati non la fanno scattare nella prima schermata (banco: 0 celle). Scatta
   ancora all'apertura delle pagine dove nell'angolo c'e' un bottone, un prezzo o una scritta che nessuno ha
   spostato (termini, contatti, ricette, la prima fila del catalogo e della ricerca...): li' la chat all'apertura
   non si vede finche' non si scorre. Se debba essere cosi' lo sceglie Giacomo (rapporto della voce); intanto vale
   la regola scritta, la bolla non copre. Il testo e le schede che scorrono possono passarle sotto (regola del
   06/10): scendendo esce, risalendo torna.
   L'ANGOLO e' fisico, a destra anche in arabo (il lato e' dell'app, non del tema): largo (96 + 20) x scala + 8,
   alto (offset + 50) x scala + 8, con 96 x 50 l'inviluppo piu' grande agli atti (85 x 46 in INBOX-ESITO). Vale in
   vetrina; in anteprima --private-preview-bar-offset (68 px) si somma, come fa la bolla.
   COL FUOCO DELLA TASTIERA sulla bolla non esce mai: un bottone fuori dallo schermo col fuoco sarebbe peggio.
   Solo della tastiera: il fuoco che resta sul bottone dopo un tocco o un clic (o che Inbox gli rende chiudendo
   la chat) non la tiene dentro. La modalita' la tiene luxury.js: pointerdown mette html.zg-mouse, Tab la toglie.
   DEGRADAZIONE: senza le classi non si muove niente; se Inbox smette di leggere la variabile la bolla torna a
   20 px; se l'elemento cambia nome i selettori non agganciano. Mai peggio di prima. Sullo scorrimento lo stesso
   ascoltatore di prima (un rAF e un'attesa), nessuna lettura per fotogramma: l'angolo si guarda a pagina ferma. */
/* IL BOTTONE DI WHATSAPP PRENDE IL POSTO DELLA BOLLA (giro finale, tappa 3, voce t3-whatsapp, 10/10/2026; foglio 10 §1.5). Il
   bottone e' un link (snippets/zg-whatsapp.liquid, [data-zg-wa]): questo file non lo crea e non lo apre, lo MUOVE con le regole
   della bolla, che passano a lui intere. Se c'e' il bottone, la bolla e' lui; se non c'e' (numero vuoto), e' ancora l'ospite di
   Inbox, com'era. Quello che cambia:
   - SALE SOPRA LE BARRE: oltre a --shopify-chat-activator-offset (per Inbox, diviso la scala) si scrive --zg-angolo-off, la
     stessa altezza non scalata (barra + 12 px al telefono, + 20 dai 768), che luxury.css da' al bottone; senza barra si tolgono
     tutte e due.
   - L'ANGOLO e' il riquadro del bottone: in orizzontale quello vero (il bottone si sposta solo in verticale), in verticale il suo
     bottom calcolato (offset, area sicura e anteprima compresi), non il riquadro, che mentre esce o rientra e' altrove; piu' gli
     stessi 8 px di respiro a sinistra e sopra: 64 x 64 a 20 px dai bordi, scala 1.
   - il fuoco della tastiera sul bottone lo tiene dentro, il bottone si salta nei punti dell'angolo, e non ha uno stato «aperto».
   Inbox ancora acceso, col bottone: luxury.css nasconde la pillola (html.zg-wa-on); qui la scala resta 1, perche' l'ospite
   nascosto non e' grande quanto la finestra, e niente altro cambia. Senza JS il bottone resta fermo al suo posto. */
(function () {
  var doc = document.documentElement;
  var ultimo = 0, attesa = false, ferma = 0, scorrendo = false, angolo = false, pianificato = false, letto = false;
  var SOGLIA = 8;    /* px: sotto questo movimento non si decide niente, cosi' un
                        dito fermo che trema non fa lampeggiare la pillola */
  var PARTE  = 120;  /* px dall'alto: sopra questa quota non esce scendendo, ed e'
                        la «prima schermata» della regola dell'angolo */
  var LARGA = 96, ALTA = 50, BORDO = 20, RESPIRO = 8; /* la bolla nell'ospite non scalato */
  var LIBERI = '.seh-cta-wrap, .fp-price-row, .fp-buy-row, .fp-notify, .lxf-bar'; /* .fp-notify: il bottone dell'avviso (t3-notify-stoq; prima .fp-notify__row, la riga del modulo contatti tolto) */
  var GRIGLIA = '.col-product-grid';
  var PANNELLI = '#luxCartDrawer.is-open, #luxCartDropdown.is-open, #wlPanel.is-open, .lux-exit.is-visible, ' +
                 '.geo-modal.is-open, .lxf-bar--mobile-open, .zg-cv-indice.is-open, .zg-cv-zoom.is-open';
  var telefono = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : null;
  var WA = '[data-zg-wa]';                  /* il bottone di WhatsApp (t3-whatsapp) */
  var BOLLE = 'shopify-chat, ' + WA;         /* la bolla, qualunque delle due */
  /* IL BOTTONE DELLA NEVE (Natale, foglio di Giacomo del 17/10/2026): in basso a sinistra, con le regole della bolla. Lo crea
     zg-natale.js (solo nel periodo) e chiama window.ZAGARA.angolo(). Qui, solo se c'e': la stessa rete dei 35 punti sul SUO angolo
     (il suo riquadro, con gli 8 px di respiro a destra e sopra), e html.zg-neve-fuori coi pannelli aperti o con qualcosa di fermo li';
     html.zg-neve-letto dopo la prima misura. Scendendo esce con html.zg-chat-away, come la bolla; col fuoco della tastiera resta
     (zg-natale.js: :focus-visible). Senza il bottone niente di questo gira e la bolla fa quello che faceva. */
  var NEVE = '[data-zg-neve]', angoloSx = false, lettoSx = false;

  function quota() { return window.scrollY || doc.scrollTop || 0; }
  /* il fuoco della TASTIERA sulla bolla: con html.zg-mouse (un tocco o un clic, luxury.js) il fuoco rimasto sul
     bottone non conta */
  function fuocoSullaBolla() {
    if (doc.classList.contains('zg-mouse')) return false;
    var a = document.activeElement;
    return !!(a && a.closest && a.closest(BOLLE));
  }

  /* 1 · scendendo esce */
  function passo() {
    attesa = false;
    var y = quota();
    var d = y - ultimo;
    if (d > SOGLIA && y > PARTE && !fuocoSullaBolla()) { doc.classList.add('zg-chat-away'); ultimo = y; }
    else if (d < -SOGLIA)        { doc.classList.remove('zg-chat-away'); ultimo = y; }
    else if (y <= PARTE)         { doc.classList.remove('zg-chat-away'); ultimo = y; }
  }
  addEventListener('scroll', function () {
    scorrendo = true;
    clearTimeout(ferma);
    ferma = setTimeout(function () { scorrendo = false; pianifica(); }, 150);
    if (attesa) return;
    attesa = true;
    requestAnimationFrame(passo);
  }, { passive: true });

  function px(nome, ripiego) {
    var v = parseFloat(getComputedStyle(doc).getPropertyValue(nome));
    return isFinite(v) ? v : ripiego;
  }
  function scala() { var s = px('--zg-bolla-s', 1); return s > 0 && s <= 1 ? s : 1; }

  /* 2 · sale sopra le barre in fondo */
  function barraSu(el) {
    if (!el.isConnected || el.hidden) return false;
    var cond = el.getAttribute('data-zg-barra-fondo');
    try { if (cond && !el.matches(cond)) return false; } catch (e) { return false; }
    var cs = getComputedStyle(el);
    return cs.position === 'fixed' && cs.display !== 'none';
  }
  function alza(s) {
    var h = 0, barre = document.querySelectorAll('[data-zg-barra-fondo]');
    for (var i = 0; i < barre.length; i++) if (barraSu(barre[i])) h = Math.max(h, barre[i].offsetHeight);
    var ora = doc.style.getPropertyValue('--shopify-chat-activator-offset');
    var oraWa = doc.style.getPropertyValue('--zg-angolo-off');
    if (h > 0) {
      var su = h + (telefono && telefono.matches ? 12 : 20);
      var off = Math.ceil(su / s) + 'px';
      if (off !== ora) doc.style.setProperty('--shopify-chat-activator-offset', off);
      if (su + 'px' !== oraWa) doc.style.setProperty('--zg-angolo-off', su + 'px');
    } else {
      if (ora) doc.style.removeProperty('--shopify-chat-activator-offset');
      if (oraWa) doc.style.removeProperty('--zg-angolo-off');
    }
  }

  /* 3 · esce coi pannelli aperti */
  function pannelloAperto() {
    var b = document.body.classList;
    return b.contains('menu-is-open') || b.contains('search-overlay-open') || !!document.querySelector(PANNELLI);
  }

  /* 4 · esce se nell'angolo c'e' qualcosa di fermo */
  function trasparente(el) {
    for (var e = el; e && e !== doc; e = e.parentElement) if (parseFloat(getComputedStyle(e).opacity) < .05) return true;
    return false;
  }
  function fisso(el) {
    for (var e = el; e && e !== document.body && e !== doc; e = e.parentElement) {
      var p = getComputedStyle(e).position;
      if (p === 'fixed' || p === 'sticky') return true;
    }
    return false;
  }
  function ultimaFila(el) {
    var scheda = el.closest(GRIGLIA + ' > *');
    if (!scheda) return false;
    var figli = scheda.parentElement.children, max = -1;
    for (var i = 0; i < figli.length; i++) if (figli[i].offsetParent) max = Math.max(max, figli[i].offsetTop);
    return scheda.offsetTop >= max - 2;
  }
  /* il testo di el dentro il rettangolo R: quello diretto, e quello dei discendenti se el e' piccolo (un titolo con
     pointer-events: none non si colpisce col punto: si trova dal contenitore). Ridà l'elemento della scritta. */
  function testoIn(el, R) {
    var r = document.createRange(), nodi = [], n;
    if (el.getElementsByTagName('*').length <= 40) {
      var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      while ((n = tw.nextNode())) nodi.push(n);
    } else {
      for (n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3) nodi.push(n);
    }
    for (var i = 0; i < nodi.length; i++) {
      if (!/\S/.test(nodi[i].nodeValue) || !nodi[i].parentElement) continue;
      r.selectNodeContents(nodi[i]);
      var q = r.getClientRects();
      for (var k = 0; k < q.length; k++) {
        if (q[k].width > 0 && q[k].right > R.l && q[k].left < R.r && q[k].bottom > R.t && q[k].top < R.b &&
            getComputedStyle(nodi[i].parentElement).visibility === 'visible') return nodi[i].parentElement;
      }
    }
    return null;
  }
  /* che cosa c'e' nell'angolo, partendo dall'elemento colpito: [elemento, 'ctrl' | 'prezzo' | 'testo'] o null
     (una foto, un fondo, il vuoto). Un prezzo conta nelle sue cifre, non nel suo riquadro: la riga del prezzo
     della scheda arriva fino all'angolo col suo padding-right (lo spazio riservato di luxury.css), ma vuota. */
  var CONTROLLI = 'button, input, select, textarea, summary, label, [role="button"], .btn, [class*="btn"]';
  function che(el, R) {
    var c = el.closest(CONTROLLI);
    if (c) return [c, 'ctrl'];
    c = el.closest('[class*="price"]');
    if (c) return testoIn(c, R) ? [c, 'prezzo'] : null;
    var a = el.closest('a[href]');
    if (a && a.offsetWidth * a.offsetHeight <= 4096) return [a, 'ctrl'];
    var t = testoIn(el, R);
    if (!t) return null;
    c = t.closest(CONTROLLI + ', a[href]');
    if (c) return [c, 'ctrl'];
    return [t, t.closest('[class*="price"]') ? 'prezzo' : 'testo'];
  }
  function angoloOccupato(s, chat, wa, sx) {
    var R;
    if (wa) {
      /* il bottone di WhatsApp: in orizzontale il suo riquadro (si sposta solo in verticale), in verticale il bottom
         calcolato (offset, area sicura e anteprima compresi: getComputedStyle da' i px usati di un elemento fixed).
         sx: il bottone della neve, a sinistra: il respiro va a destra */
      var q = wa.getBoundingClientRect(), sotto = parseFloat(getComputedStyle(wa).bottom) || 0;
      R = sx ? { l: q.left, r: q.right + RESPIRO, b: window.innerHeight - sotto } : { r: q.right, l: q.left - RESPIRO, b: window.innerHeight - sotto };
      R.t = R.b - wa.offsetHeight - RESPIRO;
    } else {
      /* il riferimento e' il box dell'ospite, dove Inbox posa la pillola (con la barra di scorrimento classica e
         scrollbar-gutter: stable e' piu' stretto di clientWidth); senza un ospite buono, la finestra */
      var W = ospite ? chat.offsetWidth : doc.clientWidth, H = ospite ? chat.offsetHeight : window.innerHeight;
      var off = px('--shopify-chat-activator-offset', 20) + px('--private-preview-bar-offset', 0);
      R = { r: W - BORDO * s, l: W - (BORDO + LARGA) * s - RESPIRO, b: H - off * s };
      R.t = R.b - ALTA * s - RESPIRO;
    }
    if (R.t < 0 || R.l < 0) return false;
    var inCima = quota() <= PARTE, visti = [];
    for (var i = 0; i < 7; i++) {
      for (var j = 0; j < 5; j++) {
        var x = R.l + (R.r - R.l) * i / 6, y = R.t + (R.b - R.t) * j / 4;
        var pila = document.elementsFromPoint(x, y), el = null;
        for (var k = 0; k < pila.length; k++) if (!pila[k].closest(BOLLE + ', ' + NEVE)) { el = pila[k]; break; }
        if (!el || el === doc || el === document.body || visti.indexOf(el) >= 0) continue;
        visti.push(el);
        var trovato = che(el, R);
        if (!trovato || trasparente(trovato[0])) continue;
        var cosa = trovato[0];
        if (inCima || fisso(cosa) || cosa.closest(LIBERI) || ultimaFila(cosa)) return true;
      }
    }
    return false;
  }

  /* la scala solo se l'ospite e' grande quanto la finestra (INBOX-ESITO): scalato dal suo angolo in basso a destra,
     un ospite diverso porterebbe la pillola altrove. Senza la classe la scala e' 1 e niente si muove di piu' di prima. */
  var ospite = false;
  function guardaOspite(chat) {
    var ok = !!chat && getComputedStyle(chat).position === 'fixed' &&
      chat.offsetWidth >= window.innerWidth - 24 && chat.offsetHeight >= window.innerHeight * .8;
    if (ok !== ospite) { ospite = ok; doc.classList.toggle('zg-bolla-ospite', ok); }
  }

  function aggiorna() {
    var chat = document.querySelector('shopify-chat'), wa = document.querySelector(WA);
    guardaOspite(chat);
    var s = scala();
    alza(s);
    if (!scorrendo) angolo = wa ? angoloOccupato(1, null, wa) : !!chat && !chat.hasAttribute('open') && angoloOccupato(s, chat);
    doc.classList.toggle('zg-bolla-fuori', !fuocoSullaBolla() && (pannelloAperto() || angolo));
    /* la prima misura e' fatta: il bottone di WhatsApp si puo' vedere (luxury.css, «PRIMA DELLA PRIMA MISURA»), un fotogramma
       dopo, quando posto e uscita sono gia' applicati senza transizione */
    if (wa && !letto) { letto = true; requestAnimationFrame(function () { doc.classList.add('zg-angolo-letto'); }); }
    /* il bottone della neve, se c'e' (qui sopra, NEVE) */
    var neve = document.querySelector(NEVE);
    if (neve) {
      if (!scorrendo) angoloSx = angoloOccupato(1, null, neve, true);
      doc.classList.toggle('zg-neve-fuori', pannelloAperto() || angoloSx);
      if (!lettoSx) { lettoSx = true; requestAnimationFrame(function () { doc.classList.add('zg-neve-letto'); }); }
    }
  }
  function pianifica() {
    if (pianificato) return;
    pianificato = true;
    requestAnimationFrame(function () { pianificato = false; aggiorna(); });
  }
  (window.ZAGARA = window.ZAGARA || {}).angolo = pianifica;   /* zg-natale.js, quando ha messo il bottone della neve */
  var mo = window.MutationObserver ? new MutationObserver(pianifica) : null;
  var ro = window.ResizeObserver ? new ResizeObserver(pianifica) : null;
  function aggancia() {
    if (mo) {
      mo.disconnect();
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      var p = document.querySelectorAll('#luxCartDrawer, #luxCartDropdown, #wlPanel, .lux-exit, .geo-modal, .lxf-bar, ' +
                                        '.zg-cv-indice, .zg-cv-zoom, [data-zg-barra-fondo], shopify-chat');
      for (var i = 0; i < p.length; i++) mo.observe(p[i], { attributes: true, attributeFilter: ['class', 'hidden', 'open'] });
    }
    if (ro) {
      ro.disconnect();
      var b = document.querySelectorAll('[data-zg-barra-fondo]');
      for (var j = 0; j < b.length; j++) ro.observe(b[j]);
    }
    pianifica();
  }
  addEventListener('resize', pianifica, { passive: true });
  if (telefono) {
    if (telefono.addEventListener) telefono.addEventListener('change', pianifica);
    else if (telefono.addListener) telefono.addListener(pianifica);
  }
  addEventListener('load', function () { pianifica(); setTimeout(pianifica, 600); setTimeout(pianifica, 1600); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pianifica);
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('shopify-chat').then(pianifica);
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.closest && e.target.closest(BOLLE)) doc.classList.remove('zg-bolla-fuori', 'zg-chat-away');
  });
  document.addEventListener('focusout', function () { setTimeout(pianifica, 0); });
  document.addEventListener('shopify:section:load', aggancia);
  document.addEventListener('shopify:section:unload', function () { setTimeout(aggancia, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aggancia, { once: true });
  else aggancia();
})();
